export const isObjectEmpty = (obj?: Record<any, any>): boolean => {
  if (obj == null) {
    return true
  }

  return Object.keys(obj).length === 0
}
